import { usePathname } from "next/navigation";

import { useLocale } from "@/context/LocaleContext";
import { getPathnameWithoutLocale } from "@/utils/getPathnameWithoutLocale";

export const usePathnameWithoutLocale = () => {
  const pathname = usePathname();
  const { currentLocale } = useLocale();
  return getPathnameWithoutLocale(pathname, currentLocale);
};
